(function () {
    function initFacetFilters() {
        const formSelector = '#FacetFiltersForm, #FacetSortForm';
        const getForms = (root = document) => Array.from(root.querySelectorAll(formSelector));
        const forms = getForms();
        const filterForm = document.getElementById('FacetFiltersForm') || document.getElementById('FacetSortForm');
        const sortForm = document.getElementById('FacetSortForm');
        const grid = document.getElementById('ProductGridList');

        if (!forms.length || !grid) return;

        const isVerticalLayout = Boolean(grid.closest('.facets-layout--vertical'));

        /* -----------------------------
           AJAX SECTION RENDER
        ----------------------------- */
        function renderPage(url, push = true, scroll = false) {
            const sectionId = grid.dataset.sectionId;

            const fetchUrl = url.includes('?') ?
                `${url}&section_id=${sectionId}` :
                `${url}?section_id=${sectionId}`;

            /* Capture filter state BEFORE replace (filters only, not sort) */
            const filterDrawer = document.getElementById('filter');
            const wasFilterDrawerOpen = filterDrawer?.classList.contains('expanded');
            const isMobile = window.innerWidth < 767;

            const openAccordionIndexes = [];
            filterForm.querySelectorAll('[data-accordion-item]').forEach((item) => {
                const panel = item.querySelector('.facet-panel');
                if (panel?.classList.contains('is-open')) {
                    const idx = item.dataset.index;
                    if (idx) openAccordionIndexes.push(idx);
                }
            });

            function applyOpenFacetState(targetForm) {
                targetForm.querySelectorAll('[data-accordion-item]').forEach((item) => {
                    if (!openAccordionIndexes.includes(item.dataset.index)) return;

                    const button = item.querySelector('.facet-trigger');
                    const panel = item.querySelector('.facet-panel');
                    const heading = item.querySelector('.facet-heading');

                    if (!button || !panel) return;

                    button.setAttribute('aria-expanded', 'true');
                    button.classList.add('active');
                    panel.classList.add('is-open', 'is-expanded');
                    if (heading) heading.classList.add('is-expanded');
                });
            }

            grid.classList.add('loading');

            fetch(fetchUrl)
                .then((res) => res.text())
                .then((html) => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');

                    const newGrid = doc.querySelector('#ProductGridList');
                    const newForms = getForms(doc);

                    if (newGrid) grid.innerHTML = newGrid.innerHTML;

                    /* Update search results count in header (outside ProductGridList) */
                    if (window.location.pathname === '/search') {
                        const countTemplate = doc.querySelector('#search-results-count-template');
                        const headerCount = document.querySelector('.search-results-count');
                        if (countTemplate && headerCount) {
                            headerCount.innerHTML = countTemplate.innerHTML;
                        }
                    }

                    if (newForms.length) {
                        forms.forEach((currentForm) => {
                            const newForm = newForms.find((item) => item.id === currentForm.id);
                            if (!newForm) return;

                            if (isVerticalLayout && currentForm.id === 'FacetFiltersForm') {
                                applyOpenFacetState(newForm);
                            }

                            if (currentForm.id === 'FacetFiltersForm' && wasFilterDrawerOpen && isMobile) {
                                /* Mobile: targeted update - preserve #filter to avoid flicker */
                                const currentFilterHead = currentForm.querySelector('#filter .filter__head');
                                const newFilterHead = newForm.querySelector('#filter .filter__head');
                                if (currentFilterHead && newFilterHead) {
                                    currentFilterHead.outerHTML = newFilterHead.outerHTML;
                                }

                                const currentFilterWrapper = currentForm.querySelector('#filter-options-wrapper');
                                const newFilterWrapper = newForm.querySelector('#filter-options-wrapper');
                                if (currentFilterWrapper && newFilterWrapper) {
                                    currentFilterWrapper.innerHTML = newFilterWrapper.innerHTML;
                                }

                                const currentActiveFacets = currentForm.querySelector('.active-facets');
                                const newActiveFacets = newForm.querySelector('.active-facets');
                                if (newActiveFacets) {
                                    if (currentActiveFacets) {
                                        currentActiveFacets.outerHTML = newActiveFacets.outerHTML;
                                    } else {
                                        const inner = currentForm.querySelector('.filters-form__inner');
                                        if (inner) inner.insertAdjacentHTML('afterend', newActiveFacets.outerHTML);
                                    }
                                } else if (currentActiveFacets) {
                                    currentActiveFacets.remove();
                                }
                            } else {
                                currentForm.innerHTML = newForm.innerHTML;
                            }
                        });

                        initAccordion();
                        initSortDropdown();
                    }

                    if (push) history.pushState({}, '', url);

                    if (scroll) {
                        // function scrollToGrid() {

                            requestAnimationFrame(() => {
                                // setTimeout(() => {
                        
                                    const gridWrapper = document.querySelector('.section-filter.facet-filters');
                                    const header = document.querySelector('.header');
                        
                                    if (!gridWrapper) return;
                        
                                    const isMobile = window.innerWidth < 767;
                        
                                    let headerOffset = 0;
                        
                                    if (header) {
                                        const headerHeight = header.getBoundingClientRect().height;
                        
                                        if (header.closest(".wrapper.no-bar")) {
                                            headerOffset = headerHeight + 10;
                                        } else {
                                            headerOffset = headerHeight + 40;
                                        }
                                    }
                        
                                    const top =
                                        gridWrapper.getBoundingClientRect().top +
                                        window.pageYOffset -
                                        (isMobile ? headerOffset : 0);
                        
                                    window.scrollTo({
                                        top,
                                        behavior: 'smooth'
                                    });
                        
                                // });
                            });
                        // }

                        // scrollToGrid();
                        
                        // window.addEventListener('resize', () => {
                        //     scrollToGrid();
                        // });
                    }

                    grid.classList.remove('loading');
                })
                .catch(() => {
                    grid.classList.remove('loading');
                });
        }

        /* -----------------------------
           FILTER HANDLER
        ----------------------------- */
        function handleFilters() {
            const formData = new FormData();

            getForms().forEach((currentForm) => {
                new FormData(currentForm).forEach((value, key) => {
                    formData.append(key, value);
                });
            });

            // Preserve search query (q) when on search page - critical for search results
            const currentParams = new URLSearchParams(window.location.search);
            const searchQuery = currentParams.get('q');
            if (searchQuery && window.location.pathname === '/search') {
                formData.set('q', searchQuery);
            }

            // Convert price to cents (Shopify requirement)
            const min = formData.get('filter.v.price.gte');
            const max = formData.get('filter.v.price.lte');

            if (min) formData.set('filter.v.price.gte', Math.round(min * 100));
            if (max) formData.set('filter.v.price.lte', Math.round(max * 100));

            const params = new URLSearchParams(formData).toString();
            const url = `${window.location.pathname}?${params}`;

            renderPage(url);
        }

        /* -----------------------------
           EVENTS
        ----------------------------- */

        forms.forEach((currentForm) => {
            if (currentForm.dataset.facetsInitialized === 'true') return;

            currentForm.addEventListener('input', handleFilters);
            currentForm.addEventListener('change', handleFilters);
            currentForm.dataset.facetsInitialized = 'true';
        });

        document.addEventListener('click', function (e) {
            const link = e.target.closest('.paging a');
            if (!link) return;

            e.preventDefault();
            renderPage(link.href, true, true);
        });

        window.addEventListener('popstate', () => {
            renderPage(location.href, false);
        });

        /* -----------------------------
            ACTIVE FILTER LINKS (AJAX)
        ----------------------------- */

        document.addEventListener('click', function (e) {
            const removeLink = e.target.closest('[data-remove-filter]');
            const clearAll = e.target.closest('[data-clear-all]');

            if (!removeLink && !clearAll) return;

            e.preventDefault();

            const url = (removeLink || clearAll).getAttribute('href');

            renderPage(url);
        });

        /* -----------------------------
            ACCESSIBLE ACCORDION
        ----------------------------- */

        function initAccordion() {

            const currentFilterForm = document.getElementById('FacetFiltersForm') || document.getElementById('FacetSortForm');
            if (!currentFilterForm) return;

            const items = currentFilterForm.querySelectorAll('[data-accordion-item]');
            const filterDrawer = document.getElementById('filter');

            if (!items.length) return;

            const isMobile = window.innerWidth < 1024;

            /* -----------------------------
               HELPERS
            ----------------------------- */

            function openItem(item) {
                const button = item.querySelector('.facet-trigger');
                const panel = item.querySelector('.facet-panel');
                const heading = item.querySelector('.facet-heading');

                if (!button || !panel) return;

                button.setAttribute('aria-expanded', 'true');
                button.classList.add('active');

                panel.classList.add('is-open', 'is-expanded');
                heading && heading.classList.add('is-expanded');
            }

            function closeItem(item) {
                const button = item.querySelector('.facet-trigger');
                const panel = item.querySelector('.facet-panel');
                const heading = item.querySelector('.facet-heading');

                if (!button || !panel) return;

                button.setAttribute('aria-expanded', 'false');
                button.classList.remove('active');

                panel.classList.remove('is-open', 'is-expanded');
                heading && heading.classList.remove('is-expanded');
            }

            function closeAll() {
                items.forEach(closeItem);
            }

            /* -----------------------------
               CLICK BEHAVIOR
            ----------------------------- */

            items.forEach((item) => {

                const button = item.querySelector('.facet-trigger');
                const panel = item.querySelector('.facet-panel');

                if (!button || !panel) return;

                button.addEventListener('click', (e) => {

                    e.stopPropagation(); // ✅ prevent outside click close

                    const isOpen =
                        button.getAttribute('aria-expanded') === 'true';

                    /* ✅ MOBILE → independent toggle */
                    if (isMobile || isVerticalLayout) {

                        if (isOpen) {
                            closeItem(item);
                        } else {
                            openItem(item);
                        }

                        return;
                    }

                    /* ✅ DESKTOP → accordion */
                    closeAll();

                    if (!isOpen) {
                        openItem(item);
                    }
                });

                // prevent panel clicks from closing
                panel.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            });

            /* -----------------------------
               OUTSIDE CLICK (DESKTOP ONLY)
            ----------------------------- */

            if (!isMobile && !isVerticalLayout) {
                document.addEventListener('click', function (e) {

                    const clickedInsideFacet =
                        e.target.closest('[data-accordion-item]');
                    const clickedFacetControl =
                        e.target.closest('[data-sort-dropdown], [data-remove-filter], [data-clear-all], .paging a');

                    if (!clickedInsideFacet && !clickedFacetControl) {
                        closeAll();
                    }
                });
            }

            /* -----------------------------
               MOBILE DEFAULT OPEN STATE
            ----------------------------- */

            function syncMobileActiveFacetState() {

                if (!isMobile) return;
                if (!filterDrawer) return;

                if (filterDrawer.classList.contains('expanded')) {
                    items.forEach((item) => {
                        const hasActiveFilter = item.querySelector('.facet-count');

                        if (hasActiveFilter) {
                            openItem(item);
                        } else {
                            closeItem(item);
                        }
                    });
                }
            }

            // run immediately
            syncMobileActiveFacetState();

            /* -----------------------------
               WATCH DRAWER OPEN
            ----------------------------- */

            document.addEventListener('click', function (e) {

                const toggle = e.target.closest(
                    '.js-btn-toggle[data-target="#filter"]'
                );

                if (!toggle) return;

                // wait for expanded class toggle
                setTimeout(syncMobileActiveFacetState, 40);
            });
        }

        initAccordion();

        function initSortDropdown() {

            const dropdown = sortForm?.querySelector('[data-sort-dropdown]') || document.querySelector('[data-sort-dropdown]');
            if (!dropdown) return;

            const trigger = dropdown.querySelector('.sorting-trigger');
            const options = dropdown.querySelectorAll('.sorting-option');
            const nativeSelect = dropdown.querySelector('.sorting-native');
            const currentLabel = dropdown.querySelector('.sorting-current');
            if (!trigger || !nativeSelect || !currentLabel || dropdown.dataset.sortInitialized === 'true') return;
            dropdown.dataset.sortInitialized = 'true';

            /* toggle */
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();

                const expanded = trigger.getAttribute('aria-expanded') === 'true';

                trigger.setAttribute('aria-expanded', !expanded);
                dropdown.querySelector('.sorting-dropdown').classList.toggle('is-open');
            });

            /* option select */
            options.forEach(option => {

                option.addEventListener('click', () => {

                    const value = option.dataset.value;

                    nativeSelect.value = value;
                    currentLabel.textContent = option.textContent;

                    options.forEach(o => o.classList.remove('is-selected'));
                    option.classList.add('is-selected');

                    trigger.setAttribute('aria-expanded', false);
                    dropdown.querySelector('.sorting-dropdown').classList.remove('is-open');

                    /* remove scroll lock only for sorting dropdown */
                    if (window.innerWidth < 767 && dropdown.closest('[data-sort-dropdown]')) {
                        document.documentElement.classList.remove('overflow-hidden');
                    }

                    /* trigger Shopify filter AJAX */
                    nativeSelect.dispatchEvent(
                        new Event('change', {
                            bubbles: true
                        })
                    );
                });
            });

            /* click outside close */
            document.addEventListener('click', (e) => {
                if (!dropdown.contains(e.target)) {
                    trigger.setAttribute('aria-expanded', false);
                    dropdown.querySelector('.sorting-dropdown').classList.remove('is-open');
                }
            });
        }
        initSortDropdown();
    }

    /* -----------------------------
       INIT (Shopify-safe)
    ----------------------------- */

    document.addEventListener('DOMContentLoaded', initFacetFilters);

    // IMPORTANT: re-init after section rendering
    document.addEventListener('shopify:section:load', initFacetFilters);
})();